<template>
	<DynamicScroller class="scroller" :id="lazyId" :min-item-size="minItemSize" :items="items">
		<template v-slot="{ item, index, active }">

			<DynamicScrollerItem class="" :item="item" :active="active" :data-index="index">
				<slot name="li" :item="item"></slot>
			</DynamicScrollerItem>
		</template>
	</DynamicScroller>
</template>

<script>
	import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
	import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
	export default {
		components: {
			DynamicScroller, DynamicScrollerItem
		},
		props: {
			items: { type: Array, required: true },
			height: { type: Number, required: true },
			lazyId: { type: String, required: true },
			minItemSize: { type: Number, default: 20 }
		},
		data() {
			return {
				style: null,
			}
		},
		created() {
			const foundStyle = document.querySelector(`style[id='${this.lazyId}']`)
			if (!foundStyle) {
				this.style = document.createElement('style')
				this.style.type = 'text/css'
				this.style.id = this.lazyId
				this.style.innerHTML = `#${this.lazyId}.vue-recycle-scroller.ready.direction-vertical.scroller { max-height: ${this.height}px !important;overflow-y: auto; }`
				document.getElementsByTagName('head')[0].appendChild(this.style)
			}
		},
		beforeUnmount() {
			document.querySelectorAll(`style[id='${this.lazyId}']`).forEach(el => el.remove())
		}
	}
</script>

<style scoped>
	.scroller {
		height: 100%;
		/*scroll-behavior: smooth;*/
	}
</style>